// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class PositionsTotalInfo {
    constructor() {
        this.accountTotalPositionAmount = new Map();
        this.accountAveragePositionPriceWithAmountBuy = new Map();
        this.accountAveragePositionPriceWithAmountSell = new Map();
        this.accountPositionAmountBuy = new Map();
        this.accountPositionAmountSell = new Map();
        this.accountTotalProfitLoss = new Map();
    }
    Clear() {
        this.accountTotalPositionAmount.clear();
        this.accountAveragePositionPriceWithAmountBuy.clear();
        this.accountAveragePositionPriceWithAmountSell.clear();
        this.accountPositionAmountBuy.clear();
        this.accountPositionAmountSell.clear();
        this.accountTotalProfitLoss.clear();
    }
}
